import { render } from "./UserGroupsTable.vue?vue&type=template&id=54d09f48&scoped=true"
import script from "./UserGroupsTable.vue?vue&type=script&lang=js"
export * from "./UserGroupsTable.vue?vue&type=script&lang=js"

import "./UserGroupsTable.vue?vue&type=style&index=0&id=54d09f48&scoped=true&lang=css"

import exportComponent from "/home/utogplukkno/www.utogplukk.no/releases/78563473/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d09f48"]])

export default __exports__